(() => {
  const initMtm = (root = document) => {
    root.querySelectorAll('[data-mil-mtm]:not([data-mil-ready])').forEach((wrapper) => {
      wrapper.dataset.milReady = 'true';
      const toggle = wrapper.querySelector('[data-mil-mtm-toggle]');
      const panel = wrapper.querySelector('[data-mil-mtm-panel]');
      const propertyInput = wrapper.querySelector('[data-mil-mtm-property]');
      const addonInput = wrapper.querySelector('[data-mil-mtm-addon]');
      const emailLater = wrapper.querySelector('[data-mil-email-later]');
      const measurementInputs = [...wrapper.querySelectorAll('[data-mil-measurement]')];
      const otherFields = [...wrapper.querySelectorAll('[data-mil-mtm-field]')];

      const syncMeasurements = () => {
        const active = !!toggle?.checked;
        const sendLater = !!emailLater?.checked;
        if (panel) panel.hidden = !active;
        if (propertyInput) propertyInput.disabled = !active;
        if (addonInput) addonInput.disabled = !active || !addonInput.value;
        if (emailLater) emailLater.disabled = !active;
        otherFields.forEach((field) => (field.disabled = !active));
        measurementInputs.forEach((field) => {
          field.disabled = !active || sendLater;
          field.required = active && !sendLater;
        });
      };

      toggle?.addEventListener('change', syncMeasurements);
      emailLater?.addEventListener('change', syncMeasurements);
      syncMeasurements();
    });
  };


  const initCustomizeModals = (root = document) => {
    root.querySelectorAll('[data-mil-customize-modal]:not([data-mil-modal-ready])').forEach((modal) => {
      modal.dataset.milModalReady = 'true';
      const modalId = modal.id;
      const openers = [...document.querySelectorAll('[data-mil-customize-open]')].filter(
        (button) => button.getAttribute('data-mil-customize-open') === modalId
      );
      const closers = [...modal.querySelectorAll('[data-mil-customize-close]')];
      const dialog = modal.querySelector('.mil-customize-modal__dialog');
      const saveButton = modal.querySelector('[data-mil-customize-save]');
      const removeButton = modal.querySelector('[data-mil-customize-remove]');
      const customizationProperty = modal.querySelector('[data-mil-customization-property]');
      const fields = [...modal.querySelectorAll('[data-mil-custom-field]')];
      const otherFields = [...modal.querySelectorAll('[data-mil-other-field]')];
      let lastFocused = null;
      let saved = false;
      const accordions = [...modal.querySelectorAll('[data-mil-custom-accordion]')];

      // Reference-style behavior: each customization category stays collapsed
      // until the customer taps it, and opening one closes the others.
      accordions.forEach((details) => {
        details.open = false;
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          accordions.forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });

      openers.forEach((button) => {
        if (!button.dataset.milOriginalLabel) button.dataset.milOriginalLabel = button.textContent.trim();
      });

      const syncOtherFields = () => {
        otherFields.forEach((field) => {
          const trigger = modal.querySelector(`[data-mil-reveal-target="${field.id}"]:checked`);
          field.hidden = !trigger;
          field.disabled = !trigger;
        });
      };

      const syncArtworkFields = () => {
        modal.querySelectorAll('[data-mil-artwork-file]').forEach((fileInput) => {
          const key = fileInput.dataset.milArtworkFile;
          const check = modal.querySelector(`[data-mil-artwork-check="${key}"]`);
          fileInput.disabled = !check?.checked;
        });
      };

      const enableForEditing = () => {
        fields.forEach((field) => (field.disabled = false));
        syncOtherFields();
        syncArtworkFields();
      };

      const disableAll = () => {
        fields.forEach((field) => (field.disabled = true));
        if (customizationProperty) customizationProperty.disabled = true;
      };

      const open = () => {
        lastFocused = document.activeElement;
        accordions.forEach((details) => { details.open = false; });
        enableForEditing();
        modal.hidden = false;
        document.body.classList.add('mil-modal-open');
        openers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
        requestAnimationFrame(() => {
          const firstField = modal.querySelector('input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled), button');
          (firstField || dialog)?.focus?.();
        });
      };

      const close = () => {
        if (!saved) disableAll();
        modal.hidden = true;
        document.body.classList.remove('mil-modal-open');
        openers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        lastFocused?.focus?.();
      };

      modal.querySelectorAll('input[type="radio"][data-mil-custom-field]').forEach((radio) => {
        radio.addEventListener('change', syncOtherFields);
      });

      modal.querySelectorAll('[data-mil-artwork-check]').forEach((check) => {
        check.addEventListener('change', syncArtworkFields);
      });

      saveButton?.addEventListener('click', () => {
        saved = true;
        if (customizationProperty) customizationProperty.disabled = false;
        syncOtherFields();
        syncArtworkFields();
        if (removeButton) removeButton.hidden = false;
        openers.forEach((button) => {
          button.classList.add('mil-customize-button--saved');
          button.textContent = 'CUSTOMIZATION SAVED ✓';
        });
        close();
      });

      removeButton?.addEventListener('click', () => {
        fields.forEach((field) => {
          if (field.type === 'radio' || field.type === 'checkbox') {
            field.checked = false;
          } else if (field.type === 'file') {
            field.value = '';
          } else if (field.tagName === 'SELECT') {
            field.selectedIndex = 0;
          } else {
            field.value = '';
          }
        });

        // Restore the first (None) radio in each group.
        const radioNames = new Set(
          fields.filter((field) => field.type === 'radio').map((field) => field.name)
        );
        radioNames.forEach((name) => {
          const first = fields.find((field) => field.type === 'radio' && field.name === name);
          if (first) first.checked = true;
        });

        saved = false;
        if (customizationProperty) customizationProperty.disabled = true;
        if (removeButton) removeButton.hidden = true;
        otherFields.forEach((field) => { field.hidden = true; });
        openers.forEach((button) => {
          button.classList.remove('mil-customize-button--saved');
          button.textContent = button.dataset.milOriginalLabel || 'CUSTOMIZE THIS PRODUCT';
        });
        disableAll();
        close();
      });

      openers.forEach((button) => button.addEventListener('click', open));
      closers.forEach((button) => button.addEventListener('click', close));
      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
      });

      disableAll();
    });
  };


  const initCircularGalleries = (root = document) => {
    root.querySelectorAll('media-gallery:not([data-mil-gallery-ready])').forEach((gallery) => {
      const nav = gallery.querySelector('[data-mil-gallery-nav]');
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!nav || !viewer) return;

      gallery.dataset.milGalleryReady = 'true';
      const previous = nav.querySelector('[data-mil-gallery-prev]');
      const next = nav.querySelector('[data-mil-gallery-next]');
      const current = nav.querySelector('[data-mil-gallery-current]');
      const total = nav.querySelector('[data-mil-gallery-total]');
      const slider = viewer.querySelector('[id^="Slider-Gallery-"]');
      let touchStartX = null;
      let touchStartY = null;
      let locked = false;

      const slides = () => [...(slider?.children || [])].filter((item) => item.matches('.product__media-item[data-media-id]'));

      const activeIndex = () => {
        const items = slides();
        const active = items.findIndex((item) => item.classList.contains('is-active'));
        if (active >= 0) return active;

        // Mobile Dawn can have several visible slides; use the closest slide to the viewport start.
        if (slider) {
          const left = slider.scrollLeft;
          let best = 0;
          let distance = Infinity;
          items.forEach((item, index) => {
            const d = Math.abs(item.offsetLeft - left);
            if (d < distance) {
              distance = d;
              best = index;
            }
          });
          return best;
        }
        return 0;
      };

      const updateCounter = (forcedIndex) => {
        const items = slides();
        if (!items.length) return;
        const index = Number.isInteger(forcedIndex) ? forcedIndex : activeIndex();
        if (current) current.textContent = String(index + 1);
        if (total) total.textContent = String(items.length);
      };

      const go = (direction) => {
        if (locked) return;
        const items = slides();
        if (items.length < 2) return;
        const from = activeIndex();
        const targetIndex = (from + direction + items.length) % items.length; // circular loop
        const target = items[targetIndex];
        if (!target) return;

        locked = true;
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(target.dataset.mediaId, false);
        } else {
          items.forEach((item) => item.classList.remove('is-active'));
          target.classList.add('is-active');
          target.parentElement?.scrollTo?.({ left: target.offsetLeft, behavior: 'smooth' });
        }
        updateCounter(targetIndex);
        window.setTimeout(() => { locked = false; }, 230);
      };

      previous?.addEventListener('click', (event) => {
        event.preventDefault();
        go(-1);
      });
      next?.addEventListener('click', (event) => {
        event.preventDefault();
        go(1);
      });

      // Keep counter synchronized with Dawn's native mobile swiping.
      viewer.addEventListener('slideChanged', (event) => {
        const items = slides();
        const index = items.indexOf(event.detail?.currentElement);
        if (index >= 0) updateCounter(index);
      });

      // Thumbnail clicks also update the counter immediately.
      gallery.querySelectorAll('[data-target]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const items = slides();
          const index = items.findIndex((item) => item.dataset.mediaId === thumb.dataset.target);
          if (index >= 0) window.setTimeout(() => updateCounter(index), 0);
        });
      });

      // Swipe left/right on the main image. Vertical page scrolling is left untouched.
      viewer.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      viewer.addEventListener('touchend', (event) => {
        if (touchStartX === null || touchStartY === null || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touchStartX;
        const dy = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        go(dx < 0 ? 1 : -1);
      }, { passive: true });

      // Keyboard navigation when focus is inside the gallery.
      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(1);
        }
      });

      updateCounter();
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initMtm();
    initCustomizeModals();
    initCircularGalleries();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initMtm(event.target);
    initCustomizeModals(event.target);
    initCircularGalleries(event.target);
  });
})();
